import type { LanguageInfo } from '../types';

/**
 * Language patterns for scripting languages
 */
export const scriptLanguagePatterns: LanguageInfo[] = [
  {
    name: 'python',
    patterns: [
      /def\s+\w+\s*\(/,
      /class\s+\w+[:\(]/,
      /import\s+[\w\s,]+/,
      /from\s+[\w.]+\s+import\s+/,
      /^\s*@\w+/m,
      /\s*=\s*None\b/,
      /:\s*(?:str|int|float|bool|list|dict|set|tuple)\b/,
      /print\s*\(/,
      /if\s+__name__\s*==\s*['"]__main__['"]/
    ],
    confidencePatterns: [/def\s+\w+\s*\([^)]*\):\s*$/m, /if\s+__name__\s*==\s*['"]__main__['"]/],
    negativePatterns: [
      /^\s*</, // HTML/XML
      /function\s+\w+/, // JavaScript/TypeScript
      /^\s*package\s+\w+/ // Java/Kotlin
    ],
    requiresMatch: 1,
    extensions: ['.py'],
    keywords: ['def', 'class', 'import', 'from', 'if', 'elif', 'else', 'try', 'except', 'self', 'None', 'True', 'False']
  },
  {
    name: 'ruby',
    patterns: [/def\s+\w+/, /class\s+\w+/, /require\s+['"][\w\/]+['"]/],
    extensions: ['.rb'],
    keywords: ['def', 'class', 'module', 'require', 'include', 'attr_accessor']
  },
  {
    name: 'shell',
    patterns: [/^#!\s*\/\w+\/\w+/, /\$\{?\w+\}?/, /export\s+\w+=/],
    extensions: ['.sh', '.bash'],
    keywords: ['if', 'then', 'else', 'fi', 'for', 'do', 'done', 'export']
  }
];
